interface ProductDetailsProps {
  selectedProduct: any;
}

export default function ProductDetails({ selectedProduct }: ProductDetailsProps) {
  if (!selectedProduct) {
    return (
      <section className="py-20 bg-gradient-to-b from-slate-900 to-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-12">
            <div className="w-24 h-24 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-ship-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-white mb-4">Detalles del Producto</h3>
            <p className="text-xl text-gray-400 mb-8">
              Selecciona un yate de nuestra flota para ver información detallada
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('productos');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:from-cyan-400 hover:to-blue-500 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-up-line mr-2"></i>Ver Productos
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-5xl font-bold bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent mb-6 font-playfair">
            Detalles del Producto
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mb-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Product Image */}
          <div className="relative">
            <div className="relative h-96 lg:h-[500px] overflow-hidden rounded-2xl border border-cyan-500/20">
              <img
                alt={selectedProduct.name}
                className="w-full h-full object-cover object-top transform hover:scale-105 transition-transform duration-500"
                src={selectedProduct.image}
              />
              <div className="absolute top-4 left-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-4 py-2 rounded-full font-bold">
                {selectedProduct.category}
              </div>
            </div>
          </div>

          {/* Product Details */}
          <div className="space-y-8">
            <div>
              <h4 className="text-4xl font-bold text-white mb-4 font-playfair">
                {selectedProduct.name}
              </h4>
              <p className="text-xl text-gray-300 leading-relaxed">
                {selectedProduct.description}
              </p>
            </div>

            {/* Specifications */}
            <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-6">
              <h5 className="text-2xl font-bold text-white mb-4 flex items-center">
                <i className="ri-settings-3-line mr-2 text-cyan-400"></i>
                Especificaciones
              </h5>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center text-gray-300">
                  <i className="ri-group-line text-cyan-400 mr-3"></i>
                  <span>Capacidad: {selectedProduct.capacity} personas</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-time-line text-cyan-400 mr-3"></i>
                  <span>Duración: {selectedProduct.hours} horas</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-ship-line text-cyan-400 mr-3"></i>
                  <span>Tipo: {selectedProduct.category}</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-money-dollar-circle-line text-cyan-400 mr-3"></i>
                  <span>Precio: ${selectedProduct.price.toLocaleString()} MXN</span>
                </div>
              </div>
            </div>

            {/* Features */}
            <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-6">
              <h5 className="text-2xl font-bold text-white mb-4 flex items-center">
                <i className="ri-star-line mr-2 text-cyan-400"></i>
                Características Incluidas
              </h5>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {selectedProduct.features.map((feature: string, index: number) => (
                  <div key={index} className="flex items-center text-gray-300">
                    <i className="ri-check-line text-emerald-400 mr-3"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Pricing */}
            <div className="bg-gradient-to-r from-cyan-500/10 to-blue-500/10 backdrop-blur-xl rounded-2xl border border-cyan-500/30 p-6">
              <div className="flex items-center justify-between mb-4">
                <h5 className="text-2xl font-bold text-white">Precio Total</h5>
                <div className="text-right">
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                    ${selectedProduct.price.toLocaleString()}
                  </div>
                  <div className="text-gray-400">MXN / {selectedProduct.hours} horas</div>
                </div>
              </div>
              <p className="text-gray-300 text-sm mb-6">
                *Precio incluye combustible, capitán profesional, seguro y equipo de seguridad básico
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="flex-1 bg-gradient-to-r from-cyan-500 to-blue-600 text-white py-4 rounded-xl font-bold hover:from-cyan-400 hover:to-blue-500 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-calendar-check-line mr-2"></i>Reservar Ahora
                </button>
                <button className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-4 rounded-xl font-bold hover:from-green-400 hover:to-green-500 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                  <i className="ri-whatsapp-line mr-2"></i>Consultar WhatsApp
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}